/**
 * Contains all the custom shaders used by the app.
 */
export class Shaders {
}
/**
 * Vertex shader used to flip a texture.
 */
Shaders.planeVertexShader = `
    varying vec2 vUv;
    uniform bool hFlip;
    uniform bool vFlip;
    
    void main()
    {
        vUv = uv;
        if (hFlip)
        {
          vUv.x = 1.0 - vUv.x;
        }
        if (vFlip)
        {
          vUv.y = 1.0 - vUv.y;
        }
        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
    }
  `;
/**
 * Fragment shader used to crop and customize contrast, brightness.
 */
Shaders.planeFragmentShader = `
    uniform sampler2D map;
    uniform float brightness;
    uniform float contrast;
    uniform vec2 topRightClip;
    uniform vec2 bottomLeftClip;

    varying vec2 vUv;

    void main()
    {
        if (vUv.x < bottomLeftClip.x || vUv.x > topRightClip.x || vUv.y < bottomLeftClip.y || vUv.y > topRightClip.y) {
          discard;
        }
        gl_FragColor = texture2D( map, vUv );
        gl_FragColor.rgb += brightness;
        if (contrast > 0.0)
        {
            gl_FragColor.rgb = clamp((gl_FragColor.rgb - 0.5) / (1.0 - contrast) + 0.5, 0.0, 1.0);
        }
        else
        {
            gl_FragColor.rgb = clamp((gl_FragColor.rgb - 0.5) * (1.0 + contrast) + 0.5, 0.0, 1.0);
        }
    }
  `;
/**
* Fragment shader used to customize contrast and brigtness.
*/
Shaders.croppedPlaneFragmentShader = `
    uniform sampler2D map;
    uniform float brightness;
    uniform float contrast;

    varying vec2 vUv;

    void main()
    {
        gl_FragColor = texture2D( map, vUv );
        gl_FragColor.rgb += brightness;
        if (contrast > 0.0)
        {
            gl_FragColor.rgb = clamp((gl_FragColor.rgb - 0.5) / (1.0 - contrast) + 0.5, 0.0, 1.0);
        }
        else
        {
            gl_FragColor.rgb = clamp((gl_FragColor.rgb - 0.5) * (1.0 + contrast) + 0.5, 0.0, 1.0);
        }
    }
  `;
//# sourceMappingURL=Shaders.js.map